import React, { useState } from 'react';
import { bool, func, string } from 'prop-types';
import _ from 'lodash'; // eslint-disable-line

import { Button, Loader, Overlay } from '@thd-olt-component-react/core-ui';

import { useCancelData } from '../../hooks/useCancelData';

import './cancel-modal.scss';

export const CancelModal = ({
  opened,
  reservationId,
  toggleOpened,
  uuid
}) => {
  const [radio, setRadio] = useState(null);

  const cancelCodes = [
    ['I need to change my reservation date.', 4],
    ['I need a different tool.', 7],
    ['I\'m concerned about the weather.', 2],
    ['My plans have changed.', 3],
    ['This is a duplicate reservation.', 5]
  ];

  const { cancelData, isLoading, cancelCall } = useCancelData({ reservationId, uuid, cancelCode: radio });

  let disabled = true;
  if (radio !== null) {
    disabled = false;
  }

  const ErrorDisplay = () => (
    <div data-testid="error-container" className="confirmation-text-container">
      <div className="error-container">
        <img
          className="error-icon"
          alt="alert"
          src="https://assets.homedepot-static.com/images/v1/alert-error-red.svg"
          height="23px"
          width="23px"
        />
        <div className="error-text">
          {cancelData.message}
        </div>
      </div>
    </div>
  );

  const SuccessDisplay = () => (
    <div data-testid="success-container" className="confirmation-text-container">
      <div className="success-container">
        <div className="success-icon  mw-icon-checkmark" />
        <div className="success-text">
          {cancelData.message}
        </div>
      </div>
      <div className="check-email-text">
        Check your email for your cancellation details.
      </div>
    </div>
  );

  return (
    <Overlay
      className="overlay"
      onClose={toggleOpened}
      open={opened}
      fit
      closeButton
      positionedCloseButton
      scrollable={false}
    >
      <div className="cancel-modal-wrapper" data-component="CancelModal">
        <div className="cancel-modal-container">
          <div className="title-bar">
            Cancel Reservation
          </div>
          <hr />
          <div className="modal-content">
            {_.isEmpty(cancelData) && !isLoading && (
              <div className="confirmation-text-container">
                <div className="confirmation-text">
                  <div>
                    Please help us to improve your rental experience.
                    Tell us why you are cancelling your reservation.
                  </div>
                </div>
                <form onSubmit={cancelCall}>
                  <div className="radio-buttons" data-testid="radio-buttons">
                    {
                      cancelCodes.map(([text, value], i) => (
                        <label
                          data-testid="radio-button"
                          className="radio-button"
                          htmlFor={`radio-${i}`}
                          key={`radio-${i}`}
                        >
                          <input
                            type="radio"
                            id={`radio-${i}`}
                            name={`radio-${i}`}
                            checked={radio === value}
                            value={value}
                            onChange={() => {
                              setRadio(value);
                            }}
                          />
                          {' '}{ text }
                        </label>
                      ))
                    }
                  </div>
                  <div className="button-container">
                    <Button
                      data-testid="cancel-reservation-button"
                      className="modal-button"
                      disabled={disabled}
                      type="button"
                      onClick={cancelCall}
                    >
                      Yes, cancel reservation
                    </Button>
                    <Button
                      data-testid="keep-reservation-button"
                      className="modal-button"
                      type="button"
                      outline
                      onClick={toggleOpened}
                    >
                      No, keep reservation
                    </Button>
                  </div>
                </form>
              </div>
            )}
            {isLoading && (
              <div className="center" data-testid="location-loader">
                <Loader active />
              </div>
            )}
            {!_.isEmpty(cancelData) && !isLoading && (
              cancelData.type === 'success'
                ? <SuccessDisplay /> : <ErrorDisplay />
            )}
          </div>
        </div>
      </div>
    </Overlay>
  );
};

CancelModal.propTypes = {
  opened: bool.isRequired,
  reservationId: string.isRequired,
  toggleOpened: func.isRequired,
  uuid: string.isRequired
};